export default {
  generic_error: 'Er is iets misgegaan',
  address_not_found:
    'Sorry, we konden dat adres niet vinden. Probeer het opnieuw door eerst de straat in te voeren in het zoekadresveld.',
  internal_error: 'Er is helaas een onverwacht probleem met je bestelling, ons technisch team werkt er al aan 🛠️.',
};
